import React from "react"
import Flex from "./Flex"
import { BoxProps } from "@mui/material"

const Column = (props: BoxProps) => (
  <Flex {...props} sx={{ ...props.sx, flexDirection: "column" }} />
)

export default Column
